import React from 'react';
import { 
  LayoutDashboard, 
  FileText, 
  Star, 
  Link2, 
  Image, 
  DollarSign, 
  Mail, 
  Users, 
  Settings, 
  BarChart3,
  UserCircle,
  ExternalLink
} from 'lucide-react';

const Sidebar = ({ activeSection, onSectionChange }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Tableau de bord', icon: LayoutDashboard },
    { id: 'blog', label: 'Articles Blog', icon: FileText },
    { id: 'reviews', label: 'Avis Clients', icon: Star },
    { id: 'links', label: 'Liens Avis', icon: Link2 },
    { id: 'portfolio', label: 'Portfolio', icon: Image },
    { id: 'pricing', label: 'Tarifs', icon: DollarSign },
    { id: 'contacts', label: 'Contacts', icon: Mail },
    { id: 'administration', label: 'Administration', icon: BarChart3 },
    { id: 'analytics', label: 'Statistiques', icon: BarChart3 },
    { id: 'settings', label: 'Paramètres', icon: Settings },
    { id: 'users', label: 'Utilisateurs', icon: UserCircle },
  ];

  return (
    <aside className="w-64 bg-gradient-to-b from-gray-900 to-gray-800 text-white min-h-screen fixed left-0 top-0 overflow-y-auto">
      {/* Logo */}
      <div className="p-6 border-b border-gray-700">
        <h1 className="text-2xl font-bold">
          GOS <span className="text-amber-500">MÉDIA</span>
        </h1>
        <p className="text-xs text-gray-400 mt-1">Administration</p>
      </div>

      {/* Menu */}
      <nav className="p-4">
        {/* View Site Button */}
        <div className="mb-4">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-medium shadow-lg transition-all duration-200"
          >
            <ExternalLink className="h-4 w-4" />
            <span>Voir le site</span>
          </a>
        </div>

        <ul className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            
            return (
              <li key={item.id}>
                <button
                  onClick={() => onSectionChange(item.id)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/50'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <Icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-700 bg-gray-900">
        <p className="text-xs text-gray-500 text-center">
          © 2026 GOS MÉDIA
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;
